var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5737 11.1765V12.6985C14.5737 13.0031 14.8208 13.25 15.1254 13.25C15.4299 13.2498 15.6763 13.003 15.6763 12.6985V11.1765H17.1991C17.5036 11.1764 17.75 10.9295 17.75 10.625C17.75 10.3205 17.5036 10.0736 17.1991 10.0735H15.6763V8.55155C15.6763 8.24705 15.4299 8.00015 15.1254 8C14.8208 8 14.5737 8.2469 14.5737 8.55155V10.0735H13.0516C12.7471 10.0735 12.5 10.3203 12.5 10.625C12.5 10.9297 12.7471 11.1765 13.0516 11.1765H14.5737Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5436 6.12512V2.92525C17.5436 1.93795 16.7433 1.1377 15.7561 1.1377H6.66524C6.19124 1.1377 5.73643 1.32602 5.40126 1.66127L1.82631 5.23629C1.12821 5.93424 1.12821 7.06615 1.82631 7.76417L5.40126 11.3391C5.73643 11.6744 6.19124 11.8627 6.66524 11.8627H10.25",
    stroke: "#0E1318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9216 4.97412C7.70738 4.97412 8.34443 5.60555 8.34443 6.39695C8.34443 7.18272 7.713 7.81977 6.9216 7.81977C6.13575 7.81977 5.49878 7.18835 5.49878 6.39695C5.49878 5.6111 6.1302 4.97412 6.9216 4.97412Z",
    fill: "#0E1318",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.44ded23b0b6082fc9696f801c653dc5e.svg";
export { ForwardRef as ReactComponent };